import { displayFontFamily, headerFontFamily } from "styles/theme";

const styles = {
  card: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    border: "1px solid rgba(0,0,0,0.07)",
    borderRadius: "18px",
    p: "26px 24px 24px",
    height: "100%",
  },
  topRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 1.5,
    mt: "6px",
    mb: "18px",
  },
  blurb: {
    display: "inline-flex",
    alignItems: "center",
    p: "6px 12px",
    backgroundColor: "#f1f0ec",
    borderRadius: "999px",
    fontFamily: headerFontFamily,
    fontSize: "12.5px",
    color: "#776B5D",
  },
  giftChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.75,
    p: "6px 11px",
    backgroundColor: "#F7EE6F",
    borderRadius: "999px",
    fontFamily: headerFontFamily,
    fontWeight: 600,
    fontSize: "12.5px",
    color: "#014339",
    whiteSpace: "nowrap",
  },
  planName: {
    fontFamily: headerFontFamily,
    fontWeight: 600,
    fontSize: "25px",
    color: "#151e16",
    lineHeight: 1.1,
    mb: "14px",
  },
  priceRow: {
    display: "flex",
    alignItems: "baseline",
    gap: "7px",
    mb: "16px",
  },
  price: {
    fontFamily: displayFontFamily,
    fontWeight: 600,
    fontSize: "42px",
    lineHeight: 1,
    color: "#151e16",
  },
  pricePer: {
    fontFamily: headerFontFamily,
    fontSize: "15px",
    color: "#776B5D",
  },
  offerBox: {
    display: "flex",
    gap: 1.25,
    alignItems: "flex-start",
    p: "13px 15px",
    backgroundColor: "#f7f6f0",
    borderRadius: "12px",
    mb: "20px",
  },
  offerEmoji: {
    fontSize: "15px",
    lineHeight: 1.3,
  },
  offerText: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#151e16",
  },
  features: {
    display: "flex",
    flexDirection: "column",
    gap: "11px",
    mb: "22px",
  },
  featureRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.25,
  },
  check: {
    flex: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 20,
    height: 20,
    borderRadius: "999px",
    backgroundColor: "#DBEFDD",
    color: "#014339",
    fontSize: "11px",
    mt: "1px",
  },
  featureText: {
    fontSize: "13.5px",
    lineHeight: 1.45,
    color: "#2c352d",
  },
  spacer: {
    flex: 1,
    minHeight: "6px",
  },
  cta: (isLive: boolean) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "50px",
    borderRadius: "999px",
    fontFamily: headerFontFamily,
    fontWeight: 600,
    fontSize: "15px",
    textTransform: "none",
    boxShadow: "none",
    ...(isLive
      ? {
          backgroundColor: "#014339",
          color: "#f7f6f0",
          "&:hover": { backgroundColor: "#165C4E", boxShadow: "none" },
        }
      : {
          backgroundColor: "#e8e6e1",
          color: "#a39b8f",
          "&.Mui-disabled": { backgroundColor: "#e8e6e1", color: "#a39b8f" },
        }),
  }),
  subNote: {
    mt: "11px",
    textAlign: "center",
    fontSize: "11.5px",
    color: "#9b958c",
  },
};

export default styles;
